webpackJsonp([65],{

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(24);




__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = "/api/";
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.withCredentials = true;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
	return response;
}, function (error) {
	if (error.response) {
		switch (error.response.status) {
			case 401:
				__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: '/' });
				break;
			default:
				break;
		}
	}
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(247);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        themecolor: localStorage.getItem('ThemeColor') ? localStorage.getItem('ThemeColor') : 'da2337' },
    mutations: {
        setThemeColor: function setThemeColor(state, curcolor) {
            alert(curcolor);
            this.state.themecolor = curcolor;
        }
    }
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installButtonDebounce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map__);


var DEFAULT_WAIT = 800;
var BUTTON_SELECTOR = ['button', 'input[type="button"]', 'input[type="submit"]', 'input[type="reset"]', '[role="button"]', '.el-button', '.btn', '.btn-div', '.add-btn', '.add-button', '.archives-btn', '.bar-code-top-btn', '.btn-css', '.btn-css-green', '.course-img-btn-sty', '.edit-package-btn', '.el-tab-pane-btn', '.endProjectBtn', '.export-btn', '.finish-btn', '.history-btn-sty', '.home-title-button', '.item-button', '.label-bar-btn', '.matching-btn', '.operate-btn', '.outline-btn', '.print-btn', '.project-btn', '.project-btn-left', '.project-btn-right', '.reset-btn', '.search-btn', '.tab-btn', '.timetable-btn', '.upload-btn', '.upload-btn-course', '.import', 'a.delete', '.download-text', '.add-class', '.item-bottom-left', '.item-bottom-right'].join(',');

var lastClickTimes = typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map___default.a === 'function' ? new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map___default.a() : null;

function matches(element, selector) {
    var matcher = element.matches || element.msMatchesSelector || element.webkitMatchesSelector;

    return matcher ? matcher.call(element, selector) : false;
}

function findButton(element) {
    while (element && element !== document) {
        if (element.nodeType === 1 && matches(element, BUTTON_SELECTOR)) {
            return element;
        }
        element = element.parentNode;
    }
    return null;
}

function isDisabled(element) {
    return element.disabled || element.getAttribute('aria-disabled') === 'true' || matches(element, '.is-disabled,.disabled');
}

function getWait(element) {
    if (!element.hasAttribute('data-click-debounce')) {
        return DEFAULT_WAIT;
    }

    var configuredWait = Number(element.getAttribute('data-click-debounce'));
    return configuredWait >= 0 ? configuredWait : DEFAULT_WAIT;
}

function getLastClickTime(element) {
    if (lastClickTimes) {
        return lastClickTimes.get(element) || 0;
    }
    return element.__buttonDebounceLastClick || 0;
}

function setLastClickTime(element, time) {
    if (lastClickTimes) {
        lastClickTimes.set(element, time);
        return;
    }
    element.__buttonDebounceLastClick = time;
}

function stopRepeatedClick(event) {
    var button = findButton(event.target);

    if (!button || isDisabled(button) || button.hasAttribute('data-allow-rapid-click')) {
        return;
    }

    var now = Date.now();
    var wait = getWait(button);
    var lastClickTime = getLastClickTime(button);

    if (now - lastClickTime < wait) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
        }
        return;
    }

    setLastClickTime(button, now);
}

function installButtonDebounce() {
    if (typeof document === 'undefined' || document.__buttonDebounceInstalled) {
        return;
    }

    document.addEventListener('click', stopRepeatedClick, true);
    document.__buttonDebounceInstalled = true;
}

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reqWxencode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return reqLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return reqUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return reqResetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reqList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return reqAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return reqEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return reqDel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return reqKdgInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return reqKdgInfoNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return reqHomeClassList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return reqHomeClassMemberTest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return reqKdgTestCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return reqKdgTestInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return reqAddressCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reqAllianceInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return reqAllianceHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return reqMarketList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return reqMarketAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return reqMarketEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return reqMarketDel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return reqLogList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return reqLogAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return reqLogEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return reqContactList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return reqContactAdd; });
/* unused harmony export reqContactEdit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return reqContactDel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return reqTeacherList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return reqTeacherAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return reqTeacherEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return reqTeacherDel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return reqAgencyProxyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return reqClassList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return reqClassAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return reqClassEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return reqClassDel; });
/* unused harmony export reqChildList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return reqChildAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return reqChildEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return reqChildDel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return reqALLChildList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return reqItemChildList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return reqTestTeacherList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return reqTestTeacherAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return reqTestTeacherEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return reqTestTeacherDel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return reqBurialPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return reqLogInformationPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return reqLogInformationPut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return reqLogInformationGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return reqCouresCustomizedGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return reqCouresLibrary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return reqCouresintelligence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return reqCouresCustomizedPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return reqExportFamilyReportA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return reqExportImprovePlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return reqExportRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return reqExportAbstract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return reqExportInfoGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return reqExportResultInfo; });
/* unused harmony export reqKindergartenHomeGet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return reqScreenChildrenClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return reqScreenChildrenSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return reqCheckAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return reqCreateTeacher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return reqUpdateTeacher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return reqDeleteTeacher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return reqTeachingCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return reqUserAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return reqPostCourseTraining; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return reqGetCourseTrainingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return reqDeleteCourseTraining; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return reqPackageCourseStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return reqPostCourseKangaroo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return reqGetCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return reqPostCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return reqDeleteCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return reqGetCourseInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return reqGetCourseListInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return reqGetCourseInfoKangaroo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return reqPostCopyCourseKangaroo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return reqGetTraining; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return reqPostTraining; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return reqDeleteTraining; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return reqGetTrainingInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return reqActivityList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




var reqWxencode = function reqWxencode(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('agency2/wxencode', params);
};

var reqLogin = function reqLogin(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('auth/logout', params).then(function (res) {
    return res.data;
  });
};

var reqUserInfo = function reqUserInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('authenticate/credentials', { params: params });
};

var reqResetPassword = function reqResetPassword(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/password/initial/", params);
};

var reqList = function reqList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/n_serviceUnit/join", { params: params });
};
var reqAdd = function reqAdd(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/n_serviceUnit/create", params);
};
var reqEdit = function reqEdit(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/n_serviceUnit/modify", params);
};
var reqDel = function reqDel(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/n_serviceUnit/delete", { params: params });
};

var reqKdgInfo = function reqKdgInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/n_serviceUnit/kg/home", { params: params });
};
var reqKdgInfoNew = function reqKdgInfoNew(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/n_serviceUnit/kg/home2", { params: params });
};
var reqHomeClassList = function reqHomeClassList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/n_serviceUnit/kg/homeClass", { params: params });
};
var reqHomeClassMemberTest = function reqHomeClassMemberTest(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/n_serviceUnit/kg/classMemberTest", { params: params });
};
var reqKdgTestCheck = function reqKdgTestCheck(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/N_Physical/GetPhysicalTest', { params: params });
};

var reqKdgTestInfo = function reqKdgTestInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/serviceUnitExport/serviceUnitAbstractA', params);
};

var reqAddressCheck = function reqAddressCheck(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/n_serviceUnit/check", { params: params });
};

var reqAllianceInfo = function reqAllianceInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/n_serviceUnit/alliance/homeInfo", { params: params });
};

var reqAllianceHistory = function reqAllianceHistory(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/n_testHistory', { params: params });
};

var reqMarketList = function reqMarketList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/N_Market/GetProject", { params: params });
};
var reqMarketAdd = function reqMarketAdd(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/N_Market/CreateProject", params);
};
var reqMarketEdit = function reqMarketEdit(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/N_Market/UpdataProject", params);
};
var reqMarketDel = function reqMarketDel(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/N_Market/DeleteProject", params);
};

var reqLogList = function reqLogList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/N_Market/Log", { params: params });
};
var reqLogAdd = function reqLogAdd(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/N_Market/Log", params);
};
var reqLogEdit = function reqLogEdit(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/N_Market/Log", params);
};

var reqContactList = function reqContactList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/N_Market/GetResourceContact", { params: params });
};
var reqContactAdd = function reqContactAdd(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/N_Market/CreateResourceContact", params);
};
var reqContactEdit = function reqContactEdit(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/N_Market/UpdateResourceContact", params);
};
var reqContactDel = function reqContactDel(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/N_Market/DeleteResourceContact", params);
};

var reqTeacherList = function reqTeacherList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/N_Market/Teacher", { params: params });
};
var reqTeacherAdd = function reqTeacherAdd(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/N_Market/Teacher", params);
};
var reqTeacherEdit = function reqTeacherEdit(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/N_Market/Teacher", params);
};
var reqTeacherDel = function reqTeacherDel(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete("/N_Market/Teacher", { params: params });
};

var reqAgencyProxyInfo = function reqAgencyProxyInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/n_serviceUnit/agencyProxy/homeInfo", { params: params });
};

var reqClassList = function reqClassList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/serviceUnitClass/classList", { params: params });
};
var reqClassAdd = function reqClassAdd(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/serviceUnitClass/createClass", params);
};
var reqClassEdit = function reqClassEdit(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/serviceUnitClass/updateClass", params);
};
var reqClassDel = function reqClassDel(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/serviceUnitClass/deleteClass", params);
};

var reqChildList = function reqChildList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/n_child/childList", { params: params });
};
var reqChildAdd = function reqChildAdd(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/n_child/create", params);
};
var reqChildEdit = function reqChildEdit(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/n_child/update", params);
};
var reqChildDel = function reqChildDel(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/n_child/delete", params);
};

var reqALLChildList = function reqALLChildList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/serviceUnitChild/childList', { params: params });
};

var reqItemChildList = function reqItemChildList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/n_child", { params: params });
};

var reqTestTeacherList = function reqTestTeacherList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/serviceUnit/miniProgramTeacherList", { params: params });
};
var reqTestTeacherAdd = function reqTestTeacherAdd(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("rc_teacher/createTeacher", params);
};
var reqTestTeacherEdit = function reqTestTeacherEdit(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("rc_teacher/updateTeacher", params);
};
var reqTestTeacherDel = function reqTestTeacherDel(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("rc_teacher/delete", params);
};

var reqBurialPoint = function reqBurialPoint(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/log/function', { params: params });
};

var reqLogInformationPost = function reqLogInformationPost(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/N_Market/Log', params);
};
var reqLogInformationPut = function reqLogInformationPut(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/N_Market/Log', params);
};
var reqLogInformationGet = function reqLogInformationGet(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/N_Market/Log', { params: params });
};

var reqCouresCustomizedGet = function reqCouresCustomizedGet(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/course/customized', { params: params });
};
var reqCouresLibrary = function reqCouresLibrary(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/course/library', { params: params });
};
var reqCouresintelligence = function reqCouresintelligence(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/course/intelligence', { params: params });
};
var reqCouresCustomizedPost = function reqCouresCustomizedPost(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/course/customized', params);
};

var reqExportFamilyReportA = function reqExportFamilyReportA(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/serviceUnitExport/serviceUnitFamilyReportA', params);
};
var reqExportImprovePlan = function reqExportImprovePlan(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/serviceUnitExport/improvePlan', { params: params });
};
var reqExportRecord = function reqExportRecord(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/serviceUnitExport/exportRecord', { params: params });
};
var reqExportAbstract = function reqExportAbstract(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/serviceUnitExport/serviceUnitAbstractA', params);
};
var reqExportInfoGet = function reqExportInfoGet(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/N_Physical/GetExportInfo', { params: params });
};

var reqExportResultInfo = function reqExportResultInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/export/FullChildResultInfo', { params: params });
};

var reqKindergartenHomeGet = function reqKindergartenHomeGet(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/n_serviceUnit/Kg/home2', { params: params });
};

var reqScreenChildrenClass = function reqScreenChildrenClass(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/serviceUnitClass/classList', { params: params });
};
var reqScreenChildrenSearch = function reqScreenChildrenSearch(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/N_Physical/ChildSearch', { params: params });
};

var reqCheckAccount = function reqCheckAccount(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/user/checkAccount', { params: params });
};
var reqCreateTeacher = function reqCreateTeacher(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/rc_teacher/createTeacher', params);
};
var reqUpdateTeacher = function reqUpdateTeacher(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/rc_teacher/updateTeacher', params);
};
var reqDeleteTeacher = function reqDeleteTeacher(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/rc_teacher/delete', params);
};
var reqTeachingCase = function reqTeachingCase(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/course/teachingcase', { params: params });
};
var reqUserAuth = function reqUserAuth(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/users/userAuth', params);
};
var reqPostCourseTraining = function reqPostCourseTraining(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/contents/packages', params);
};
var reqGetCourseTrainingList = function reqGetCourseTrainingList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/contents/packages', { params: params });
};
var reqDeleteCourseTraining = function reqDeleteCourseTraining(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/contents/packages', { params: params });
};
var reqPackageCourseStatus = function reqPackageCourseStatus(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/contents/packagesStatus', params);
};
var reqPostCourseKangaroo = function reqPostCourseKangaroo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/courses/kangaroo', params);
};

var reqGetCourse = function reqGetCourse(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/courses', { params: params });
};
var reqPostCourse = function reqPostCourse(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/courses', params);
};
var reqDeleteCourse = function reqDeleteCourse(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/courses', { params: params });
};
var reqGetCourseInfo = function reqGetCourseInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/courses/info', { params: params });
};
var reqGetCourseListInfo = function reqGetCourseListInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/courses/package/info', { params: params });
};
var reqGetCourseInfoKangaroo = function reqGetCourseInfoKangaroo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/courses/kangarooCourseInfo', { params: params });
};
var reqPostCopyCourseKangaroo = function reqPostCopyCourseKangaroo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/courses/kangarooCopyCourse', params);
};

var reqGetTraining = function reqGetTraining(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/trainings', { params: params });
};
var reqPostTraining = function reqPostTraining(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/trainings', params);
};
var reqDeleteTraining = function reqDeleteTraining(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/trainings', { params: params });
};
var reqGetTrainingInfo = function reqGetTrainingInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/trainings/info', { params: params });
};

var reqActivityList = function reqActivityList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/activities', { params: params });
};

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toggleClass;

function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  element.className = className;
}

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(233)
__webpack_require__(234)

var Component = __webpack_require__(70)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(244),
  /* scopeId */
  "data-v-d8b000a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_headTop__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_headTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_headTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_theme_da2337_index_css__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_theme_da2337_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_css_theme_da2337_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_theme_14A83B_index_css__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_theme_14A83B_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_css_theme_14A83B_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_common_css__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_less_color_less__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_less_color_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_less_color_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_index__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_config__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_context__ = __webpack_require__(71);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {};
    },

    components: {
        headTop: __WEBPACK_IMPORTED_MODULE_0__components_headTop___default.a
    },
    mounted: function mounted() {
        var apiRoot = window.location.host.split('.')[0];
        var adminUser = __WEBPACK_IMPORTED_MODULE_6__assets_js_config__["a" /* default */].apiRoot[apiRoot];

        var app = document.getElementById("app");
        if (adminUser.RequestUnit == 'IsFangCao') {
            app.className = "theme-fangcao";
        } else if (adminUser.RequestUnit == 'IsAixiuxing') {
            app.className = "theme-reliable";
        } else if (adminUser.RequestUnit == 'localhost:8099') {
            app.className = "theme-reliable";
        } else {
            app.className = "theme-reliable";
        }
    }
});

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_context__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_config__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api__ = __webpack_require__(116);









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            requestUnit: '',
            apiRootName: '',
            logoImg: '',
            dialogFormVisible: false,
            dialog: false,
            dalogTxt: '',
            passForm: {
                oldPassword: '',
                newPassword: ''
            },
            admin: '',
            dataroles: 0,
            topLogoImg: false,
            passFormRules: {
                oldPassword: [{
                    required: true,
                    message: '请输入密码',
                    trigger: 'blur'
                }],
                newPassword: [{
                    required: true,
                    message: '请输入密码',
                    trigger: 'blur'
                }]
            },
            routes: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].routes,
            allianceRoutes: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].allianceRoutes,
            agencyRoutes: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].agencyRoutes,
            proxyRoutes: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].proxyRoutes,
            kgRoutes: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].kgRoutes,
            kgRoutesProbation: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].kgRoutesProbation,
            fangCaoKgRoutes: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].fangCaoKgRoutes,
            fangCaoAllianceRoutes: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].fangCaoAllianceRoutes,
            fangCaoProxyRoutes: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].fangCaoProxyRoutes,
            kindergartenDataBase: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].kindergartenDataBase,
            allianceChildRoutes: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].allianceChildRoutes,
            agencyProxyRoutes: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].agencyProxyRoutes,
            courseManagementRoutes: __WEBPACK_IMPORTED_MODULE_4__assets_js_nav_head__["a" /* default */].courseManagementRoutes,
            roleTypes: __WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].RoleType
        };
    },


    methods: {
        updatedDalog: function updatedDalog(type) {
            var txt = '版本：4.9<br>更新日期：2018.10.29<br><br>更新内容：<br>1.幼儿管理新增批量离校功能，孩子离校及毕业操作更方便;<br>2.修复其他已知bug，优化使用体验;<br>';
            var txtObj = {
                '0': txt,
                '1': txt,
                '4': txt,
                '6': txt,
                '5': txt
            };
            this.dialog = true;
            this.dalogTxt = txtObj[type];
        },
        unlockingUser: function unlockingUser() {
            var _this2 = this;

            var _this = this;
            this.$confirm('您确定要为用户解锁码?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this.$http.put('auth/logout');
                _this2.$message({
                    type: 'success',
                    message: '解锁成功!'
                });
            }).catch(function () {
                _this2.$message({
                    type: 'info',
                    message: '已取消解锁'
                });
            });
        },
        getKdgRoleType: function getKdgRoleType() {
            var unitType = __WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].UnitType;
            var userNameObj = {
                '1': '园长',
                '4': '机构',
                '6': '加盟商',
                '5': '代理',
                '9': '课程管理员'
            };
            if (__WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].RequestUnit == 'IsFangCao') {
                if (__WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].RoleType == 0) {
                    this.dataroles = 0;
                } else {
                    this.dataroles = unitType;
                };
                this.admin = '管理员';
            } else {
                if (__WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].RoleType == 0) {
                    this.dataroles = 0;
                    this.admin = '管理员';
                } else if (__WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].RoleType == 100) {
                    this.dataroles = 100;
                    this.admin = '管理员';
                } else {
                    if (__WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].IsProbation == 'true') {
                        this.dataroles = 7;
                        this.admin = userNameObj[1];
                    } else {
                        this.dataroles = unitType;
                        this.admin = userNameObj[unitType];
                    }
                };
            }
        },

        logout: function logout() {
            var _this = this;
            this.$confirm('确认退出吗?', '提示', {}).then(function () {
                _this.$http.get('auth/logout');
                __WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].Clear();
                _this.$router.push('/');
            });
        },
        editSubmit: function editSubmit() {
            var _this3 = this;

            if (__WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].IsFakeAccount == 'true') {
                alert('试用账号无法修改密码');
            } else {
                this.$refs.passForm.validate(function (valid) {
                    if (valid) {
                        var para = {
                            OldPassword: _this3.passForm.oldPassword,
                            NewPassword: _this3.passForm.newPassword
                        };
                        _this3.$http.put('/password', para).then(function (response) {
                            if (response.status == 200) {
                                _this3.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                                _this3.dialogFormVisible = false;
                                var _this = _this3;
                                _this.$http.get('auth/logout');
                                __WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].Clear();
                                _this.$router.push('/');
                            }
                        }).catch(function () {
                            _this3.$message({
                                message: '请检查输入是否正确',
                                type: 'error'
                            });
                        });
                    }
                });
            }
        },
        getKdgInfo: function getKdgInfo(kdgName) {
            var _this4 = this;

            var unitType = __WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].UnitType;
            var roleType = __WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].RoleType;
            this.dataroles = roleType == 0 || roleType == 100 ? roleType : unitType;

            var parameter = {
                UnitType: 1,
                PageIndex: 1,
                Keyword: kdgName,
                PageSize: 20
            };
            console.log(this.dataroles);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* reqList */])(parameter).then(function (res) {
                _this4.loading = false;
                if (res.data) {
                    var kdgList = res.data.KdgList;
                    kdgList.forEach(function (element) {
                        if (element.Resullts.AllianceName == '体测教师培训班') {
                            __WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].IsProbation = true;
                        } else {
                            __WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].IsProbation = false;
                        };
                    });
                };
                _this4.getKdgRoleType();
            });
        }
    },
    mounted: function mounted() {
        this.getKdgInfo(__WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].KindergartenName);
        var apiRoot = window.location.host.split('.')[0];
        var adminUser = __WEBPACK_IMPORTED_MODULE_2__assets_js_config__["a" /* default */].apiRoot[apiRoot];
        this.apiRootName = adminUser.Name;
        this.requestUnit = adminUser.RequestUnit;
        __WEBPACK_IMPORTED_MODULE_1__utils_context__["a" /* default */].RequestUnit = adminUser.RequestUnit;;
        this.topLogoImg = adminUser.Title == '贝玛教育' ? true : false;
        this.logoImg = '/static/images/' + adminUser.Logo;
    }
});

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    routes: [{
        path: '/importData',
        name: '数据导入'
    }, {
        path: '/kgList/Master?user=baibai',
        name: '幼儿园管理'
    }],

    agencyProxyRoutes: [{
        path: '/allianceList',
        name: '加盟商管理'
    }, {
        path: '/agencyList/Master?user=baibai',
        name: '机构管理'
    }, {
        path: '/proxyList/Master?user=baibai',
        name: '代理管理'
    }],

    courseManagementRoutes: [{
        path: '/course',
        name: '课程'
    }, {
        path: '/training',
        name: '师训'
    }, {
        path: '/activity',
        name: '活动'
    }, {
        path: '/kangarooCoursePackage',
        name: '袋鼠圈课程'
    }],

    allianceRoutes: [{
        path: '/allianceMain/allianceMaster/allianceHome',
        name: '主页'
    }, {
        path: '/allianceMain/allianceProject/projectSpeed',
        name: '项目进度'
    }, {
        path: '/allianceMain/allianceMaster/teacherPlatform',
        name: '师资平台'
    }, {
        path: '/allianceMain/allianceMaster/kdgConnect',
        name: '园所沟通'
    }],

    agencyRoutes: [{
        path: '/importData',
        name: '数据导入'
    }, {
        path: '/agencyHome',
        name: '机构主页'
    }, {
        path: '/kgList/Agency',
        name: '园所管理'
    }],

    proxyRoutes: [{
        path: '/proxyHome',
        name: '代理主页'
    }, {
        path: '/kgList/Proxy',
        name: '园所管理'
    }, {
        path: '/importData',
        name: '数据导入'
    }],

    kgRoutes: [{
        path: '/kindergartenMain/kindergartenMaster/kgHomeNew',
        name: '园所主页'
    }, {
        path: '/kindergartenMain/kdg/exercisePlan',
        name: '体格锻炼计划'
    }, {
        path: '/kindergartenMain/kdg/childList',
        name: '幼儿园管理'
    }, {
        path: '/kindergartenMain/kdg/teacherManagement',
        name: '教师管理'
    }, {
        path: '/kindergartenMain/kdg/screeningChildren',
        name: '幼儿筛选'
    }],

    kgRoutesBeiMa: [{
        path: '/kindergartenMain/kindergartenMaster/kgHomeNew',
        name: '园所主页'
    }, {
        path: '/kindergartenMain/kdg/childList',
        name: '幼儿园管理'
    }, {
        path: '/kindergartenMain/kdg/teacherManagement',
        name: '教师管理'
    }, {
        path: '/kindergartenMain/kdg/screeningChildren',
        name: '幼儿筛选'
    }],

    kgRoutesProbation: [{
        path: '/kindergartenMain/kindergartenMaster/kgHomeNew',
        name: '园所主页'
    }, {
        path: '/kindergartenMain/kdg/childList',
        name: '幼儿园管理'
    }, {
        path: '/kindergartenMain/kdg/screeningChildren',
        name: '幼儿筛选'
    }],

    kindergartenDataBase: [{
        path: '/importData',
        name: '数据导入'
    }, {
        path: '/kindergartenMain/kdg/exportReport',
        name: '数据导出'
    }],

    allianceChildRoutes: [{
        path: '/kgList/index',
        name: '幼儿园管理'
    }, {
        path: '/agencyList/index',
        name: '机构管理'
    }, {
        path: '/proxyList/index',
        name: '代理管理'
    }, {
        path: '/allianceMain/allianceMaster/allianceHistoryList',
        name: '历史测试'
    }],

    fangCaoKgRoutes: [{
        path: '/kindergartenMain/kindergartenMaster/kgHomeNew',
        name: '园所主页'
    }, {
        path: '/kindergartenMain/kdg/childList',
        name: '幼儿园管理'
    }, {
        path: '/kindergartenMain/kdg/teacherManagement',
        name: '教师管理'
    }, {
        path: '/kindergartenMain/kdg/screeningChildren',
        name: '幼儿筛选'
    }],

    fangCaoProxyRoutes: [{
        path: '/proxyHome',
        name: '代理主页'
    }, {
        path: '/kgList/Proxy',
        name: '园所管理'
    }, {
        path: '/importData',
        name: '数据导入'
    }],

    fangCaoAllianceRoutes: [{
        path: '/allianceMain/allianceMaster/allianceHome',
        name: '主页'
    }, {
        path: '/kgList/index',
        name: '幼儿园管理'
    }, {
        path: '/proxyList/index',
        name: '代理管理'
    }, {
        path: '/allianceMain/allianceMaster/allianceHistoryList',
        name: '历史测试'
    }]
});

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_validator__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_http__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_button_debounce__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_index__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_css__);


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_2__api_http__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$store = __WEBPACK_IMPORTED_MODULE_7__store_index__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_validator___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_bootstrap_vue__["a" /* default */]);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_button_debounce__["a" /* installButtonDebounce */])();

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var login = function login(r) {
    return __webpack_require__.e/* require.ensure */(48).then((function () {
        return r(__webpack_require__(311));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var main = function main(r) {
    return __webpack_require__.e/* require.ensure */(63).then((function () {
        return r(__webpack_require__(251));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var kgList = function kgList(r) {
    return __webpack_require__.e/* require.ensure */(18).then((function () {
        return r(__webpack_require__(304));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var kindergartenMain = function kindergartenMain(r) {
    return __webpack_require__.e/* require.ensure */(12).then((function () {
        return r(__webpack_require__(306));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var kgHome = function kgHome(r) {
    return __webpack_require__.e/* require.ensure */(11).then((function () {
        return r(__webpack_require__(303));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var kgHomeNew = function kgHomeNew(r) {
    return __webpack_require__.e/* require.ensure */(3).then((function () {
        return r(__webpack_require__(302));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var childList = function childList(r) {
    return __webpack_require__.e/* require.ensure */(28).then((function () {
        return r(__webpack_require__(295));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var exportReport = function exportReport(r) {
    return __webpack_require__.e/* require.ensure */(27).then((function () {
        return r(__webpack_require__(299));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var checkData = function checkData(r) {
    return __webpack_require__.e/* require.ensure */(41).then((function () {
        return r(__webpack_require__(294));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var kgTestReport = function kgTestReport(r) {
    return __webpack_require__.e/* require.ensure */(14).then((function () {
        return r(__webpack_require__(305));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var screeningChildren = function screeningChildren(r) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
        return r(__webpack_require__(307));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var familyReport = function familyReport(r) {
    return __webpack_require__.e/* require.ensure */(8).then((function () {
        return r(__webpack_require__(300));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var termOutline = function termOutline(r) {
    return __webpack_require__.e/* require.ensure */(32).then((function () {
        return r(__webpack_require__(310));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var courseContent = function courseContent(r) {
    return __webpack_require__.e/* require.ensure */(40).then((function () {
        return r(__webpack_require__(297));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var exercisePlan = function exercisePlan(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__(298));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var teacherManagement = function teacherManagement(r) {
    return __webpack_require__.e/* require.ensure */(21).then((function () {
        return r(__webpack_require__(308));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var teachingProgram = function teachingProgram(r) {
    return __webpack_require__.e/* require.ensure */(49).then((function () {
        return r(__webpack_require__(309));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var classHome = function classHome(r) {
    return __webpack_require__.e/* require.ensure */(6).then((function () {
        return r(__webpack_require__(296));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var gradeHome = function gradeHome(r) {
    return __webpack_require__.e/* require.ensure */(4).then((function () {
        return r(__webpack_require__(301));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var allianceList = function allianceList(r) {
    return __webpack_require__.e/* require.ensure */(15).then((function () {
        return r(__webpack_require__(257));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var allianceMain = function allianceMain(r) {
    return __webpack_require__.e/* require.ensure */(13).then((function () {
        return r(__webpack_require__(258));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var allianceHome = function allianceHome(r) {
    return __webpack_require__.e/* require.ensure */(22).then((function () {
        return r(__webpack_require__(256));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var allianceHistoryList = function allianceHistoryList(r) {
    return __webpack_require__.e/* require.ensure */(45).then((function () {
        return r(__webpack_require__(255));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var projectSpeed = function projectSpeed(r) {
    return __webpack_require__.e/* require.ensure */(36).then((function () {
        return r(__webpack_require__(263));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var projectInformation = function projectInformation(r) {
    return __webpack_require__.e/* require.ensure */(37).then((function () {
        return r(__webpack_require__(262));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var resourceTelephone = function resourceTelephone(r) {
    return __webpack_require__.e/* require.ensure */(30).then((function () {
        return r(__webpack_require__(264));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var teacherPlatform = function teacherPlatform(r) {
    return __webpack_require__.e/* require.ensure */(29).then((function () {
        return r(__webpack_require__(265));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var kdgConnect = function kdgConnect(r) {
    return __webpack_require__.e/* require.ensure */(16).then((function () {
        return r(__webpack_require__(260));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var logInfo = function logInfo(r) {
    return __webpack_require__.e/* require.ensure */(38).then((function () {
        return r(__webpack_require__(261));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var addEditKdg = function addEditKdg(r) {
    return __webpack_require__.e/* require.ensure */(39).then((function () {
        return r(__webpack_require__(259));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var introduction = function introduction(r) {
    return __webpack_require__.e/* require.ensure */(57).then((function () {
        return r(__webpack_require__(285));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var promotionalMaterials = function promotionalMaterials(r) {
    return __webpack_require__.e/* require.ensure */(53).then((function () {
        return r(__webpack_require__(289));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var governmentInfo = function governmentInfo(r) {
    return __webpack_require__.e/* require.ensure */(59).then((function () {
        return r(__webpack_require__(283));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var activityScheme = function activityScheme(r) {
    return __webpack_require__.e/* require.ensure */(60).then((function () {
        return r(__webpack_require__(282));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var planScheme = function planScheme(r) {
    return __webpack_require__.e/* require.ensure */(54).then((function () {
        return r(__webpack_require__(288));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var testInstruction = function testInstruction(r) {
    return __webpack_require__.e/* require.ensure */(50).then((function () {
        return r(__webpack_require__(292));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var systemUse = function systemUse(r) {
    return __webpack_require__.e/* require.ensure */(51).then((function () {
        return r(__webpack_require__(291));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var hardwareEquip = function hardwareEquip(r) {
    return __webpack_require__.e/* require.ensure */(58).then((function () {
        return r(__webpack_require__(284));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var parentMeet = function parentMeet(r) {
    return __webpack_require__.e/* require.ensure */(55).then((function () {
        return r(__webpack_require__(287));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var propagandaMater = function propagandaMater(r) {
    return __webpack_require__.e/* require.ensure */(52).then((function () {
        return r(__webpack_require__(290));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var packaging = function packaging(r) {
    return __webpack_require__.e/* require.ensure */(56).then((function () {
        return r(__webpack_require__(286));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var agencyList = function agencyList(r) {
    return __webpack_require__.e/* require.ensure */(23).then((function () {
        return r(__webpack_require__(253));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var agencyHome = function agencyHome(r) {
    return __webpack_require__.e/* require.ensure */(31).then((function () {
        return r(__webpack_require__(252));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var testersManagement = function testersManagement(r) {
    return __webpack_require__.e/* require.ensure */(19).then((function () {
        return r(__webpack_require__(254));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var proxyList = function proxyList(r) {
    return __webpack_require__.e/* require.ensure */(20).then((function () {
        return r(__webpack_require__(314));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var proxyHome = function proxyHome(r) {
    return __webpack_require__.e/* require.ensure */(26).then((function () {
        return r(__webpack_require__(313));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var importData = function importData(r) {
    return __webpack_require__.e/* require.ensure */(17).then((function () {
        return r(__webpack_require__(293));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var other = function other(r) {
    return __webpack_require__.e/* require.ensure */(47).then((function () {
        return r(__webpack_require__(312));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var course = function course(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(270));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var kangarooCoursePackage = function kangarooCoursePackage(r) {
    return __webpack_require__.e/* require.ensure */(34).then((function () {
        return r(__webpack_require__(274), 'kangarooCoursePackage');
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var kangarooCourseList = function kangarooCourseList(r) {
    return __webpack_require__.e/* require.ensure */(42).then((function () {
        return r(__webpack_require__(273), 'kangarooCourseList');
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var kangarooCoursePackageEdit = function kangarooCoursePackageEdit(r) {
    return __webpack_require__.e/* require.ensure */(9).then((function () {
        return r(__webpack_require__(275), 'kangarooCoursePackageEdit');
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var kangarooCourseEdit = function kangarooCourseEdit(r) {
    return __webpack_require__.e/* require.ensure */(7).then((function () {
        return r(__webpack_require__(272), 'kangarooCourseEdit');
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var contentPackageEdit = function contentPackageEdit(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(267));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var training = function training(r) {
    return __webpack_require__.e/* require.ensure */(61).then((function () {
        return r(__webpack_require__(278));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var activity = function activity(r) {
    return __webpack_require__.e/* require.ensure */(44).then((function () {
        return r(__webpack_require__(266));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var trainingEdit = function trainingEdit(r) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
        return r(__webpack_require__(276));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var courseEdit = function courseEdit(r) {
    return __webpack_require__.e/* require.ensure */(10).then((function () {
        return r(__webpack_require__(268));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var coursePackage = function coursePackage(r) {
    return __webpack_require__.e/* require.ensure */(43).then((function () {
        return r(__webpack_require__(269));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var trainingPackage = function trainingPackage(r) {
    return __webpack_require__.e/* require.ensure */(62).then((function () {
        return r(__webpack_require__(277));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var exporTeachingPlan = function exporTeachingPlan(r) {
    return __webpack_require__.e/* require.ensure */(35).then((function () {
        return r(__webpack_require__(271));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var exporCourseContentPrint = function exporCourseContentPrint(r) {
    return __webpack_require__.e/* require.ensure */(25).then((function () {
        return r(__webpack_require__(279));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var exporOutDoorGamesPrint = function exporOutDoorGamesPrint(r) {
    return __webpack_require__.e/* require.ensure */(24).then((function () {
        return r(__webpack_require__(280));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var CourseReportDerive = function CourseReportDerive(r) {
    return __webpack_require__.e/* require.ensure */(33).then((function () {
        return r(__webpack_require__(281));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var weCode = function weCode(r) {
    return __webpack_require__.e/* require.ensure */(46).then((function () {
        return r(__webpack_require__(315));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        component: login
    }, {
        path: '/main',
        component: main,
        children: [{
            path: '/kgList/:userId',
            name: 'kgList',
            component: kgList
        }, {
            path: '/kindergartenMain/:id',
            component: kindergartenMain,
            children: [{
                path: 'kgHome',
                component: kgHome
            }, {
                path: 'childList',
                component: childList
            }, {
                path: 'exportReport',
                component: exportReport
            }, {
                path: 'checkData',
                component: checkData
            }, {
                path: 'kgTestReport',
                component: kgTestReport
            }, {
                path: 'kgHomeNew',
                component: kgHomeNew
            }, {
                path: 'screeningChildren',
                component: screeningChildren
            }, {
                path: 'familyReport',
                component: familyReport
            }, {
                path: 'termOutline',
                component: termOutline
            }, {
                path: 'courseContent',
                component: courseContent
            }, {
                path: 'exercisePlan',
                component: exercisePlan
            }, {
                path: 'teacherManagement',
                component: teacherManagement
            }, {
                path: 'teachingProgram',
                component: teachingProgram
            }, {
                path: 'classHome',
                component: classHome
            }, {
                path: 'gradeHome',
                component: gradeHome
            }]
        }, {
            path: '/allianceList',
            component: allianceList
        }, {
            path: '/allianceMain/:id',
            component: allianceMain,
            children: [{
                path: 'allianceHome',
                component: allianceHome
            }, {
                path: 'allianceHistoryList',
                component: allianceHistoryList
            }, {
                path: 'projectSpeed',
                component: projectSpeed
            }, {
                path: 'projectInformation',
                component: projectInformation
            }, {
                path: 'resourceTelephone',
                component: resourceTelephone
            }, {
                path: 'teacherPlatform',
                component: teacherPlatform
            }, {
                path: 'kdgConnect',
                component: kdgConnect
            }, {
                path: 'logInfo',
                component: logInfo
            }, {
                path: 'addEditKdg',
                component: addEditKdg
            }, {
                path: 'introduction',
                component: introduction
            }, {
                path: 'promotionalMaterials',
                component: promotionalMaterials
            }, {
                path: 'governmentInfo',
                component: governmentInfo
            }, {
                path: 'activityScheme',
                component: activityScheme
            }, {
                path: 'planScheme',
                component: planScheme
            }, {
                path: 'testInstruction',
                component: testInstruction
            }, {
                path: 'systemUse',
                component: systemUse
            }, {
                path: 'hardwareEquip',
                component: hardwareEquip
            }, {
                path: 'parentMeet',
                component: parentMeet
            }, {
                path: 'propagandaMater',
                component: propagandaMater
            }, {
                path: 'packaging',
                component: packaging
            }]
        }, {
            path: '/agencyList/:userId',
            name: 'agencyList',
            component: agencyList

        }, {
            path: '/agencyHome',
            component: agencyHome
        }, {
            path: '/proxyList/:userId',
            name: 'proxyList',
            component: proxyList
        }, {
            path: '/proxyHome',
            component: proxyHome
        }, {
            path: '/testersManagement',
            component: testersManagement
        }, {
            path: '/importData',
            component: importData
        }, {
            path: '/course',
            component: course
        }, {
            path: '/training',
            component: training
        }, {
            path: '/kangarooCoursePackage',
            component: kangarooCoursePackage
        }, {
            path: '/kangarooCourseList',
            component: kangarooCourseList
        }, {
            path: '/kangarooCoursePackageEdit',
            component: kangarooCoursePackageEdit
        }, {
            path: '/kangarooCourseEdit',
            component: kangarooCourseEdit
        }, {
            path: '/contentPackageEdit',
            component: contentPackageEdit
        }, {
            path: '/activity',
            component: activity
        }, {
            path: '/trainingEdit',
            component: trainingEdit
        }, {
            path: '/courseEdit',
            component: courseEdit
        }, {
            path: '/coursePackage',
            component: coursePackage
        }, {
            path: '/trainingPackage',
            component: trainingPackage
        }, {
            path: '/exporTeachingPlan',
            component: exporTeachingPlan
        }, {
            path: '/exporCourseContentPrint',
            component: exporCourseContentPrint
        }, {
            path: '/exporOutDoorGamesPrint',
            component: exporOutDoorGamesPrint
        }, {
            path: '/CourseReportDerive',
            component: CourseReportDerive
        }, {
            path: '/other',
            component: other
        }, {
            path: '/wechatCode',
            component: weCode
        }]
    }]
}));

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticClass: "head-nav"
  }, [_c('el-col', {
    staticClass: "logo-box",
    attrs: {
      "span": 4
    }
  }, [_c('img', {
    class: {
      topLogoImg: _vm.topLogoImg
    },
    attrs: {
      "src": _vm.logoImg
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.apiRootName))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(_vm.dataroles == 0) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.routes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name) + "\n\t\t\t\t\t\t\t")])
  }), _vm._v(" "), _c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("机构管理菜单")]), _vm._v(" "), _vm._l((_vm.agencyProxyRoutes), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2), _vm._v(" "), _c('el-menu-item', {
    key: "/other",
    staticClass: "color-fff $route.path==/other'is-active':''",
    attrs: {
      "index": "/other"
    }
  }, [_vm._v("其它\n\t\t\t\t\t\t\t")])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 100) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active1",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("课程管理菜单")]), _vm._v(" "), _vm._l((_vm.courseManagementRoutes), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 6 && _vm.requestUnit != 'IsFangCao' && _vm.requestUnit != 'IsBeiMa') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 6) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.allianceRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_c('span', [_vm._v(_vm._s(route.name))])])
  }), _vm._v(" "), _c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("信息管理")]), _vm._v(" "), _vm._l((_vm.allianceChildRoutes), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2), _vm._v(" "), _c('el-menu-item', {
    key: "/importData",
    staticClass: "color-fff $route.path==/main/import_data?'is-active':''",
    attrs: {
      "index": "/importData"
    }
  }, [_vm._v("数据导入\n\t\t\t\t\t")]), _vm._v(" "), _c('el-menu-item', {
    key: "/allianceMain/helpCenter/introduction",
    staticClass: "color-fff $route.path==/main4/introduction?index=3'is-active':''",
    attrs: {
      "index": "/allianceMain/helpCenter/introduction"
    }
  }, [_vm._v("帮助中心\n\t\t\t\t\t")])], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 6 && (_vm.requestUnit == 'IsFangCao' || _vm.requestUnit == 'IsBeiMa')) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 6) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.fangCaoAllianceRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_c('span', [_vm._v(_vm._s(route.name))])])
  }), _vm._v(" "), _c('el-menu-item', {
    key: "/importData",
    staticClass: "color-fff $route.path==/main/import_data?'is-active':''",
    attrs: {
      "index": "/importData"
    }
  }, [_vm._v("数据导入\n\t\t\t\t\t")]), _vm._v(" "), _c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("课程管理菜单")]), _vm._v(" "), _vm._l((_vm.courseManagementRoutes), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2)], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 4) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 4) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, _vm._l((_vm.agencyRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  })) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 5 && _vm.requestUnit == 'IsFangCao') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 5) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, _vm._l((_vm.fangCaoProxyRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  })) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 5 && _vm.requestUnit != 'IsFangCao') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 5) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, _vm._l((_vm.proxyRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  })) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 1 && (_vm.requestUnit == 'IsFangCao' || _vm.requestUnit == 'IsBeiMa')) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 1) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.fangCaoKgRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  }), _vm._v(" "), _c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("数据处理")]), _vm._v(" "), _vm._l((_vm.kindergartenDataBase), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2)], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 1 && _vm.requestUnit != 'IsFangCao' && _vm.requestUnit != 'IsBeiMa') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 1) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.kgRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  }), _vm._v(" "), _c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("数据处理")]), _vm._v(" "), _vm._l((_vm.kindergartenDataBase), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2)], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 7 && _vm.requestUnit != 'IsFangCao') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 7) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.kgRoutesProbation), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  }), _vm._v(" "), _c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("数据处理")]), _vm._v(" "), _vm._l((_vm.kindergartenDataBase), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2)], 2) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    staticClass: "userinfo "
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/user-icon.png"
    }
  }), _vm._v("\n\t\t\t\t\t    " + _vm._s(_vm.admin) + " "), _c('i', {
    staticClass: "el-icon-arrow-down"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "userinfo-dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.dataroles !== 0) ? _c('el-dropdown-item', [_c('span', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t修改密码\n\t\t\t\t\t\t\t")])]) : _c('el-dropdown-item'), _vm._v(" "), _c('el-dropdown-item', [_c('span', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t退出登录\n\t\t\t\t\t\t\t\t")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.dialogFormVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "passForm",
    attrs: {
      "model": _vm.passForm,
      "label-width": "70px",
      "rules": _vm.passFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旧密码",
      "prop": "oldPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.passForm.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "oldPassword", $$v)
      },
      expression: "passForm.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.passForm.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "newPassword", $$v)
      },
      expression: "passForm.newPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5,
      "offset": 5
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提 交")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "版本更新",
      "visible": _vm.dialog,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "70px"
    }
  }, [_c('p', {
    staticClass: "update-dialog-p",
    domProps: {
      "innerHTML": _vm._s(_vm.dalogTxt)
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5,
      "offset": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(232)

var Component = __webpack_require__(70)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(243),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	get IsFakeAccount() {
		return window.localStorage.IsFakeAccount;
	},
	set IsFakeAccount(IsFakeAccount) {
		window.localStorage.IsFakeAccount = IsFakeAccount;
	},
	get ServiceUnitId() {
		return window.localStorage.ServiceUnitId;
	},
	set ServiceUnitId(serviceUnitId) {
		window.localStorage.ServiceUnitId = serviceUnitId;
	},

	set ServiceUnitName(serviceUnitName) {
		window.localStorage.ServiceUnitName = serviceUnitName;
	},
	get ServiceUnitName() {
		return window.localStorage.ServiceUnitName;
	},
	get UnitType() {
		return window.localStorage.UnitType;
	},
	set UnitType(unitType) {
		window.localStorage.UnitType = unitType;
	},
	get RoleType() {
		return window.localStorage.RoleType;
	},
	set RoleType(roleType) {
		window.localStorage.RoleType = roleType;
	},
	get KindergartenName() {
		return window.localStorage.KindergartenName;
	},
	set KindergartenName(kindergartenName) {
		window.localStorage.KindergartenName = kindergartenName;
	},
	get KindergartenId() {
		return window.localStorage.KindergartenId;
	},
	set KindergartenId(kindergartenId) {
		window.localStorage.KindergartenId = kindergartenId;
	},
	get AgencyId() {
		return window.localStorage.AgencyId;
	},
	set AgencyId(agencyId) {
		window.localStorage.AgencyId = agencyId;
	},
	get AllianceId() {
		return window.localStorage.AllianceId;
	},
	set AllianceId(allianceId) {
		window.localStorage.AllianceId = allianceId;
	},
	get ProxyId() {
		return window.localStorage.ProxyId;
	},
	set ProxyId(proxyId) {
		window.localStorage.ProxyId = proxyId;
	},

	get ProjectName() {
		return window.localStorage.ProjectName;
	},
	set ProjectName(projectName) {
		window.localStorage.ProjectName = projectName;
	},
	get ProjectCreatTime() {
		return window.localStorage.ProjectCreatTime;
	},
	set ProjectCreatTime(projectCreatTime) {
		window.localStorage.ProjectCreatTime = projectCreatTime;
	},
	get ProjectDescription() {
		return window.localStorage.ProjectDescription;
	},
	set ProjectDescription(projectDescription) {
		window.localStorage.ProjectDescription = projectDescription;
	},
	get UserId() {
		return window.localStorage.UserId;
	},
	set UserId(userId) {
		window.localStorage.UserId = userId;
	},
	get ProjectStatus() {
		return window.localStorage.ProjectStatus;
	},
	set ProjectStatus(projectStatus) {
		window.localStorage.ProjectStatus = projectStatus;
	},

	get ProjectId() {
		return window.localStorage.ProjectId;
	},
	set ProjectId(projectId) {
		window.localStorage.ProjectId = projectId;
	},

	get ServiceUnitGrade() {
		return window.localStorage.ServiceUnitGrade;
	},
	set ServiceUnitGrade(serviceUnitGrade) {
		window.localStorage.ServiceUnitGrade = serviceUnitGrade;
	},
	get GartenId() {
		return window.localStorage.GartenId;
	},
	set GartenId(gartenId) {
		window.localStorage.GartenId = gartenId;
	},

	get ChildId() {
		return window.localStorage.ChildId;
	},
	set ChildId(childId) {
		window.localStorage.ChildId = childId;
	},
	get TargetMonth() {
		return window.localStorage.TargetMonth;
	},
	set TargetMonth(targetMonth) {
		window.localStorage.TargetMonth = targetMonth;
	},
	get TargetYear() {
		return window.localStorage.TargetYear;
	},
	set TargetYear(targetYear) {
		window.localStorage.TargetYear = targetYear;
	},

	get Grade() {
		return window.localStorage.Grade;
	},
	set Grade(grade) {
		window.localStorage.Grade = grade;
	},

	set RequestUnit(requestUnit) {
		window.localStorage.RequestUnit = requestUnit;
	},
	get RequestUnit() {
		return window.localStorage.RequestUnit;
	},

	set ThemeColor(themeColor) {
		window.localStorage.ThemeColor = themeColor;
	},
	get ThemeColor() {
		return window.localStorage.ThemeColor;
	},

	set IsProbation(isProbation) {
		window.localStorage.IsProbation = isProbation;
	},
	get IsProbation() {
		return window.localStorage.IsProbation;
	},

	Clear: function Clear() {
		window.localStorage.clear();
	}

});

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	options: [{
		value: '3',
		label: '未联系'
	}, {
		value: '4',
		label: '无意向'
	}, {
		value: '5',
		label: '意向一般'
	}, {
		value: '6',
		label: '意向明确'
	}, {
		value: '7',
		label: '已合作'
	}],
	optionsAll: [{
		value: '0',
		label: '全部'
	}, {
		value: '3',
		label: '未联系'
	}, {
		value: '4',
		label: '无意向'
	}, {
		value: '5',
		label: '意向一般'
	}, {
		value: '6',
		label: '意向明确'
	}, {
		value: '7',
		label: '已合作'
	}],
	apiRoot: {
		'114': {
			Title: '睿莱',
			Name: '睿莱体测',
			Logo: 'logo.png',
			LoginBg: 'login.png',
			Color: 'da2337',
			RequestUnit: 'IsAReliable'
		},
		'tice': {
			Title: '雏鹰',
			Name: '雏鹰体测',
			Logo: 'logo-chuying.png',
			LoginBg: 'login-chuying.png',
			Color: 'da2337',
			RequestUnit: 'IsChuYing'
		},
		'admin': {
			Title: '睿莱',
			Name: '睿莱体测',
			Logo: 'logo.png',
			LoginBg: 'login.png',
			Color: 'da2337',
			RequestUnit: 'IsAReliable'
		},
		'atest': {
			Title: '睿莱',
			Name: '睿莱体测',
			Logo: 'logo.png',
			LoginBg: 'login.png',
			Color: 'da2337',
			RequestUnit: 'IsAReliable'
		},
		'ra': {
			Title: '睿莱',
			Name: '睿莱体测',
			Logo: 'logo.png',
			LoginBg: 'login.png',
			Color: 'da2337',
			RequestUnit: 'IsAReliable'
		},
		'fangcao': {
			Title: '芳草教育',
			Name: '',
			Logo: 'logo-fangcao.png',
			LoginBg: 'login-fangcao.png',
			Color: '14A83B',
			RequestUnit: 'IsFangCao'
		},
		'61park': {
			Title: '贝玛教育',
			Name: '',
			Logo: 'logo-beima.png',
			LoginBg: 'login-beima.png',
			Color: 'da2337',
			RequestUnit: 'IsBeiMa'
		},

		'axs': {
			Title: '艾秀星',
			Name: '',
			Logo: 'logo-aixiuxing.png',
			LoginBg: 'login-aixiuxing.png',
			Color: 'da2337',
			RequestUnit: 'IsAixiuxing'
		},
		'localhost:8099': {
			Title: '睿莱',
			Name: '睿莱体测',
			Logo: 'logo.png',
			LoginBg: 'login.png',
			Color: 'da2337',
			RequestUnit: 'IsAReliable'
		}
	},

	genderType: {
		'1': '男',
		'2': '女'
	},
	rankType: {
		'0': '需努力',
		'1': '需努力',
		'2': '较差',
		'3': '合格',
		'4': '良好',
		'5': '优秀'
	},
	weightRank: {
		"-1": "偏轻",
		"-3": "偏轻",
		'5': "正常",
		'3': "偏胖",
		'1': "肥胖"
	},
	classType: {
		'10': '大班',
		'11': '中班',
		'12': '小班',
		'13': '托班',
		'14': '混龄班',
		'15': '学前班'
	},
	classTypeSVG: {
		'10': '大班',
		'11': '中班',
		'12': '小班',
		'13': '托班',
		'14': '混龄班',
		'15': '学前班',
		'90': '全园平均',
		'99': '全国平均'
	},
	missTypeVal: {
		'0': '已测完',
		'undefined': '未测试',
		'1': '测试中',
		'2': '因故缺席',
		'4': '未测试'
	},

	projectType: {
		'12': {
			Name: '身高',
			Score: 'HeightScore',
			Rank: 'HeightRank',
			Unit: 'cm'
		},
		'13': {
			Name: '体重',
			Score: 'WeightScore',
			Rank: 'WeightRank',
			Unit: 'kg'
		},
		'14': {
			Name: '坐位体前屈',
			Score: 'SitReachScore',
			Rank: 'SitReachRank',
			Unit: 'cm'
		},
		'15': {
			Name: '立定跳远',
			Score: 'BroadJumpScore',
			Rank: 'BroadJumpRank',
			Unit: 'cm'
		},
		'16': {
			Name: '双脚连续跳',
			Score: 'DoubleJumpScore',
			Rank: 'DoubleJumpRank',
			Unit: 's'
		},
		'17': {
			Name: '十米折返跑',
			Score: 'ShuttleRunScore',
			Rank: 'ShuttleRunRank',
			Unit: 's'
		},
		'18': {
			Name: '网球掷远',
			Score: 'ThrowScore',
			Rank: 'ThrowRank',
			Unit: 'm'
		},
		'19': {
			Name: '走平衡木',
			Score: 'BalanceScore',
			Rank: 'BalanceRank',
			Unit: 's'
		},
		'20': {
			Name: '运动能力',
			Score: 'SportAbiltyScore',
			Rank: 'SportAbility',
			Unit: 's'
		}
	},

	totalRankOptions: [{
		value: '0',
		label: '全部'
	}, {
		value: '1',
		label: '需努力'
	}, {
		value: '2',
		label: '合格'
	}, {
		value: '3',
		label: '良好'
	}, {
		value: '4',
		label: '优秀'
	}],
	testTypeOptions: [{
		value: '-99',
		label: '全部'
	}, {
		value: '0',
		label: '已测试'
	}, {
		value: '1',
		label: '测试中'
	}, {
		value: '2',
		label: '因故缺席'
	}, {
		value: '3',
		label: '未测试'
	}],
	genderOptions2: [{
		value: '0',
		label: '全部'
	}, {
		value: '1',
		label: '男'
	}, {
		value: '2',
		label: '女'
	}],
	projectIdOptions2: [{
		value: '0',
		label: '全部'
	}, {
		value: '12',
		label: '身高'
	}, {
		value: '13',
		label: '体重'
	}, {
		value: '14',
		label: '柔韧性（坐位体前屈）'
	}, {
		value: '15',
		label: '下肢力量（立定跳远）'
	}, {
		value: '16',
		label: '协调性（双脚连续跳）'
	}, {
		value: '17',
		label: '灵敏性（十米折返跑）'
	}, {
		value: '18',
		label: '上肢力量（网球掷远）'
	}, {
		value: '19',
		label: '平衡力（平衡木）'
	}, {
		value: '20',
		label: '运动能力'
	}],
	projectIdOptions: [{
		value: '0',
		label: '全部'
	}, {
		value: '12',
		label: '身高'
	}, {
		value: '13',
		label: '体重'
	}, {
		value: '14',
		label: '柔韧性（坐位体前屈）'
	}, {
		value: '15',
		label: '下肢力量（立定跳远）'
	}, {
		value: '16',
		label: '协调性（双脚连续跳）'
	}, {
		value: '17',
		label: '灵敏性（十米折返跑）'
	}, {
		value: '18',
		label: '上肢力量（网球掷远）'
	}, {
		value: '19',
		label: '平衡力（平衡木）'
	}],

	projectRankOptions: [{
		value: '0',
		label: '全部'
	}, {
		value: '2',
		label: '需努力'
	}, {
		value: '3',
		label: '合格'
	}, {
		value: '4',
		label: '良好'
	}, {
		value: '5',
		label: '优秀'
	}],
	gradeOptions: [{
		value: '0',
		label: '全部'
	}, {
		value: '10',
		label: '大班'
	}, {
		value: '11',
		label: '中班'
	}, {
		value: '12',
		label: '小班'
	}, {
		value: '13',
		label: '托班'
	}, {
		value: '14',
		label: '混龄班'
	}, {
		value: '15',
		label: '学前班'
	}],
	classIdOptions: [{
		value: '0',
		label: '全部'
	}],
	resetSearchForm: {
		TotalRank: '0',
		TestType: '-99',
		Gender: '0',
		ProjectId: '0',
		ProjectRank: '0',
		Grade: '0',
		ClassId: '0'
	},

	divClass: ['top-right', 'middle1-right', 'middle2-right', 'bottom-right', 'bottom-left', 'middle2-left', 'middle1-left', 'top-left'],

	iconClass: ['top-right-icon', 'middle1-right-icon', 'middle2-right-icon', 'bottom-right-icon', 'bottom-left-icon', 'middle2-left-icon', 'middle1-left-icon', 'top-left-icon'],

	iconArrowClass: ['top-right-arrow-icon', 'middle1-right-arrow-icon', 'middle2-right-arrow-icon', 'bottom-right-arrow-icon', 'bottom-left-arrow-icon', 'middle2-left-arrow-icon', 'middle1-left-arrow-icon', 'top-left-arrow-icon'],

	evaluate: {
		5: {
			rank: '优秀',
			backgroud: '#edf7fd',
			txt: '孩子表现的很好，继续保持。'
		},
		4: {
			rank: '良好',
			backgroud: '#edf7fd',
			txt: '孩子表现的很好，继续保持。'
		},
		3: {
			rank: '合格',
			backgroud: '#edf7fd',
			txt: '孩子表现还不错，继续努力。'
		},
		2: {
			rank: '需努力',
			backgroud: '#f8e8ea',
			txt: '孩子表现不是很理想，家长需多关注。'
		},
		1: {
			rank: '需努力',
			backgroud: '#f8e8ea',
			txt: '孩子表现不是很理想，家长需多关注。'
		},
		0: {
			rank: '需努力',
			backgroud: '#f8e8ea',
			txt: '孩子表现不是很理想，家长需多关注。'
		}
	},

	majorPhysicalFitnessId: {
		1: '灵敏',
		2: '平衡',
		3: '协调',
		4: '柔韧',
		5: '上肢',
		6: '下肢'
	},

	courseQuality: [{
		name: 'Association',
		lable: '同伴交往'
	}, {
		name: 'RuleConsciousness',
		lable: '规则意识'
	}, {
		name: 'Teamwork',
		lable: '团队协作'
	}, {
		name: 'Competitive',
		lable: '竞争意识'
	}, {
		name: 'ExerciseHabit',
		lable: '运动习惯'
	}],

	coursePhysicalQuality: [{
		name: 'Balance',
		lable: '平衡'
	}, {
		name: 'Coordinate',
		lable: '协调'
	}, {
		name: 'Sensitive',
		lable: '灵敏'
	}, {
		name: 'Flexible',
		lable: '柔韧'
	}, {
		name: 'UpperLimbStrength',
		lable: '上肢力量'
	}, {
		name: 'LowerLimbStrength',
		lable: '下肢力量'
	}],

	gameSensePerception: [{
		name: 'Direction',
		lable: '方向'
	}, {
		name: 'Altitude',
		lable: '高度'
	}, {
		name: 'Heft',
		lable: '重量'
	}, {
		name: 'Gravity',
		lable: '重力'
	}, {
		name: 'Space',
		lable: '空间'
	}, {
		name: 'Colour',
		lable: '颜色'
	}, {
		name: 'Form',
		lable: '形状'
	}, {
		name: 'Longness',
		lable: '长度'
	}, {
		name: 'Proprioception',
		lable: '本体感觉'
	}],

	coursePurpose: [{
		name: 'Walk',
		lable: '走',
		type: '1'
	}, {
		name: 'Run',
		lable: '跑',
		type: '1'
	}, {
		name: 'ObstacleRun',
		lable: '障碍跑',
		type: '1'
	}, {
		name: 'ReverseRun',
		lable: '变向跑',
		type: '1'
	}, {
		name: 'Hop',
		lable: '单脚跳',
		type: '1'
	}, {
		name: 'SkipJump',
		lable: '双脚跳',
		type: '1'
	}, {
		name: 'StepJump',
		lable: '跨跳',
		type: '1'
	}, {
		name: 'Bore',
		lable: '钻',
		type: '1'
	}, {
		name: 'SideDrill',
		lable: '侧身钻',
		type: '1'
	}, {
		name: 'FrontDrill',
		lable: '正面钻',
		type: '1'
	}, {
		name: 'CrossFeet',
		lable: '交叉步',
		type: '1'
	}, {
		name: 'Glissade',
		lable: '滑步',
		type: '1'
	}, {
		name: 'FrontSlidingStep',
		lable: '前滑步',
		type: '1'
	}, {
		name: 'SideSlide',
		lable: '侧滑步',
		type: '1'
	}, {
		name: 'HandKneeClimbing',
		lable: '手膝爬',
		type: '1'
	}, {
		name: 'HandFootCrawling',
		lable: '手脚爬',
		type: '1'
	}, {
		name: 'Crawl',
		lable: '匍匐爬',
		type: '1'
	}, {
		name: 'JumpFromHeight',
		lable: '从高处跳下',
		type: '1'
	}, {
		name: 'JumpHigh',
		lable: '向高处跳',
		type: '1'
	}, {
		name: 'FeetLongJump',
		lable: '双脚跳远',
		type: '1'
	}, {
		name: 'Throw',
		lable: '投掷',
		type: '2'
	}, {
		name: 'ThrowBallOnTheGround',
		lable: '抛掷地滚球',
		type: '2'
	}, {
		name: 'LowHandThrow',
		lable: '低手投掷',
		type: '2'
	}, {
		name: 'HandThrow',
		lable: '双手投掷',
		type: '2'
	}, {
		name: 'OneHandedShoulderThrow',
		lable: '单手肩上投掷',
		type: '2'
	}, {
		name: 'Embrace',
		lable: '抱',
		type: '2'
	}, {
		name: 'Raise',
		lable: '抬',
		type: '2'
	}, {
		name: 'Carry',
		lable: '端',
		type: '2'
	}, {
		name: 'Press',
		lable: '压',
		type: '2'
	}, {
		name: 'Shove',
		lable: '推',
		type: '2'
	}, {
		name: 'Pull',
		lable: '拉',
		type: '2'
	}, {
		name: 'Prehension',
		lable: '抓握',
		type: '2'
	}, {
		name: 'HoldUp',
		lable: '举',
		type: '2'
	}, {
		name: 'TumblingObject',
		lable: '翻滚物体',
		type: '2'
	}, {
		name: 'RollingObject',
		lable: '滚动物体',
		type: '2'
	}, {
		name: 'BounceBall',
		lable: '拍球',
		type: '2'
	}, {
		name: 'Kick',
		lable: '踢',
		type: '2'
	}, {
		name: 'KickFixedBall',
		lable: '脚踢固定球',
		type: '2'
	}, {
		name: 'FootDribble',
		lable: '脚运球',
		type: '2'
	}, {
		name: 'CatchBall',
		lable: '接球',
		type: '2'
	}, {
		name: 'Impact',
		lable: '击打',
		type: '2'
	}, {
		name: 'ShoulderStrike',
		lable: '肩上击打',
		type: '2'
	}, {
		name: 'BothHandsHitSideways',
		lable: '双手体侧击打',
		type: '2'
	}, {
		name: 'JumpLowFromHigh',
		lable: '从高处向低处跳',
		type: '3'
	}, {
		name: 'JumpHighLower',
		lable: '低处向高处跳',
		type: '3'
	}, {
		name: 'Squat',
		lable: '下蹲',
		type: '3'
	}, {
		name: 'BalancedWalk',
		lable: '平衡行走',
		type: '3'
	}, {
		name: 'BalanceStand',
		lable: '燕式平衡',
		type: '3'
	}, {
		name: 'StandOneLeg',
		lable: '单脚站立',
		type: '3'
	}, {
		name: 'BendingStretching',
		lable: '弯曲与伸展',
		type: '3'
	}, {
		name: 'LateralTorsion',
		lable: '侧扭转',
		type: '3'
	}, {
		name: 'BendingStanding',
		lable: '弯曲与直立',
		type: '3'
	}, {
		name: 'TransportObject',
		lable: '搬运物体',
		type: '3'
	}, {
		name: 'DynamicBalanc',
		lable: '动态平衡',
		type: '3'
	}, {
		name: 'StaticBalanc',
		lable: '静态平衡',
		type: '3'
	}, {
		name: 'BendingCrimp',
		lable: '弯曲与卷曲',
		type: '3'
	}, {
		name: 'Turn',
		lable: '转体',
		type: '3'
	}, {
		name: 'TurnRound',
		lable: '扭转',
		type: '3'
	}, {
		name: 'Stretch',
		lable: '伸展',
		type: '3'
	}, {
		name: 'ShiftCenterGravity',
		lable: '转移重心',
		type: '3'
	}],

	coursesPage: [{
		Label: "走",
		Name: "Walk",
		Result: "",
		Type: 11
	}, {
		Label: "跑",
		Name: "Run",
		Result: "",
		Type: 11
	}, {
		Label: "障碍跑",
		Name: "ObstacleRun",
		Result: "",
		Type: 11
	}, {
		Label: "变向跑",
		Name: "ReverseRun",
		Result: "",
		Type: 11
	}, {
		Label: "双脚跳",
		Name: "SkipJump",
		Result: "",
		Type: 11
	}, {
		Label: "跨跳",
		Name: "StepJump",
		Result: "",
		Type: 11
	}, {
		Label: "钻",
		Name: "Bore",
		Result: "",
		Type: 11
	}, {
		Label: "侧身钻",
		Name: "SideDrill",
		Result: "",
		Type: 11
	}, {
		Label: "正面钻",
		Name: "FrontDrill",
		Result: "",
		Type: 11
	}, {
		Label: "交叉步",
		Name: "CrossFeet",
		Result: "",
		Type: 11
	}, {
		Label: "滑步",
		Name: "Glissade",
		Result: "",
		Type: 11
	}, {
		Label: "前滑步",
		Name: "FrontSlidingStep",
		Result: "",
		Type: 11
	}, {
		Label: "侧滑步",
		Name: "SideSlide",
		Result: "",
		Type: 11
	}, {
		Label: "手膝爬",
		Name: "HandKneeClimbing",
		Result: "",
		Type: 11
	}, {
		Label: "手脚爬",
		Name: "HandFootCrawling",
		Result: "",
		Type: 11
	}, {
		Label: "匍匐爬",
		Name: "Crawl",
		Result: "",
		Type: 11
	}, {
		Label: "从高处跳下",
		Name: "JumpFromHeight",
		Result: "",
		Type: 11
	}, {
		Label: "向高处跳",
		Name: "JumpHigh",
		Result: "",
		Type: 11
	}, {
		Label: "双脚跳远",
		Name: "FeetLongJump",
		Result: "",
		Type: 11
	}, {
		Label: "单脚跳",
		Name: "Hop",
		Result: "",
		Type: 11
	}, {
		Label: "投掷",
		Name: "Throw",
		Result: "",
		Type: 22
	}, {
		Label: "抛掷地滚球",
		Name: "ThrowBallOnTheGround",
		Result: "",
		Type: 22
	}, {
		Label: "低手投掷",
		Name: "LowHandThrow",
		Result: "",
		Type: 22
	}, {
		Label: "双手投掷",
		Name: "HandThrow",
		Result: "",
		Type: 22
	}, {
		Label: "单手肩上投掷",
		Name: "OneHandedShoulderThrow",
		Result: "",
		Type: 22
	}, {
		Label: "抱",
		Name: "Embrace",
		Result: "",
		Type: 22
	}, {
		Label: "抬",
		Name: "Raise",
		Result: "",
		Type: 22
	}, {
		Label: "端",
		Name: "Carry",
		Result: "",
		Type: 22
	}, {
		Label: "压",
		Name: "Press",
		Result: "",
		Type: 22
	}, {
		Label: "推",
		Name: "Shove",
		Result: "",
		Type: 22
	}, {
		Label: "拉",
		Name: "Pull",
		Result: "",
		Type: 22
	}, {
		Label: "抓握",
		Name: "Prehension",
		Result: "",
		Type: 22
	}, {
		Label: "举",
		Name: "HoldUp",
		Result: "",
		Type: 22
	}, {
		Label: "翻滚物体",
		Name: "TumblingObject",
		Result: "",
		Type: 22
	}, {
		Label: "滚动物体",
		Name: "RollingObject",
		Result: "",
		Type: 22
	}, {
		Label: "拍球",
		Name: "BounceBall",
		Result: "",
		Type: 22
	}, {
		Label: "踢",
		Name: "Kick",
		Result: "",
		Type: 22
	}, {
		Label: "脚踢固定球",
		Name: "KickFixedBall",
		Result: "",
		Type: 22
	}, {
		Label: "脚运球",
		Name: "FootDribble",
		Result: "",
		Type: 22
	}, {
		Label: "接球",
		Name: "CatchBall",
		Result: "",
		Type: 22
	}, {
		Label: "击打",
		Name: "Impact",
		Result: "",
		Type: 22
	}, {
		Label: "肩上击打",
		Name: "ShoulderStrike",
		Result: "",
		Type: 22
	}, {
		Label: "双手体侧击打",
		Name: "BothHandsHitSideways",
		Result: "",
		Type: 22
	}, {
		Label: "从高处向低处跳",
		Name: "JumpLowFromHigh",
		Result: "",
		Type: 33
	}, {
		Label: "从低处向高处跳",
		Name: "JumpHighLower",
		Result: "",
		Type: 33
	}, {
		Label: "下蹲",
		Name: "Squat",
		Result: "",
		Type: 33
	}, {
		Label: "平衡行走",
		Name: "BalancedWalk",
		Result: "",
		Type: 33
	}, {
		Label: "燕式平衡",
		Name: "BalanceStand",
		Result: "",
		Type: 33
	}, {
		Label: "单脚站立",
		Name: "StandOneLeg",
		Result: "",
		Type: 33
	}, {
		Label: "弯曲与伸展",
		Name: "BendingStretching",
		Result: "",
		Type: 33
	}, {
		Label: "侧扭转",
		Name: "LateralTorsion",
		Result: "",
		Type: 33
	}, {
		Label: "弯曲与直立",
		Name: "BendingStanding",
		Result: "",
		Type: 33
	}, {
		Label: "搬运物体",
		Name: "TransportObject",
		Result: "",
		Type: 33
	}, {
		Label: "动态平衡",
		Name: "DynamicBalanc",
		Result: "",
		Type: 33
	}, {
		Label: "静态平衡",
		Name: "StaticBalanc",
		Result: "",
		Type: 33
	}, {
		Label: "弯曲与卷曲",
		Name: "BendingCrimp",
		Result: "",
		Type: 33
	}, {
		Label: "转体",
		Name: "Turn",
		Result: "",
		Type: 33
	}, {
		Label: "扭转",
		Name: "TurnRound",
		Result: "",
		Type: 33
	}, {
		Label: "伸展",
		Name: "Stretch",
		Result: "",
		Type: 33
	}, {
		Label: "转移重心",
		Name: "ShiftCenterGravity",
		Result: "",
		Type: 33
	}, {
		Label: "平衡",
		Name: "Balance",
		Result: '',
		Type: 44
	}, {
		Label: "协调",
		Name: "Coordinate",
		Result: '',
		Type: 44
	}, {
		Label: "灵敏",
		Name: "Sensitive",
		Result: '',
		Type: 44
	}, {
		Label: "柔韧",
		Name: "Flexible",
		Result: '',
		Type: 44
	}, {
		Label: "上肢力量",
		Name: "UpperLimbStrength",
		Result: '',
		Type: 44
	}, {
		Label: "下肢力量",
		Name: "LowerLimbStrength",
		Result: '',
		Type: 44
	}, {
		Label: "同伴交往",
		Name: "Association",
		Type: 55,
		Result: ''

	}, {
		Label: "规则意识",
		Name: "RuleConsciousness",
		Type: 55,
		Result: ''
	}, {
		Label: "团队协作",
		Name: "Teamwork",
		Type: 55,
		Result: ''
	}, {
		Label: "竞争意识",
		Name: "Competitive",
		Type: 55,
		Result: ''
	}, {
		Label: "运动习惯",
		Name: "ExerciseHabit",
		Type: 55,
		Result: ''
	}, {
		Label: "方向",
		Name: "Direction",
		Result: "",
		Type: 66
	}, {
		Label: "高度",
		Name: "Altitude",
		Result: "",
		Type: 66
	}, {
		Label: "重量",
		Name: "Heft",
		Result: "",
		Type: 66
	}, {
		Label: "重力",
		Name: "Gravity",
		Result: "",
		Type: 66
	}, {
		Label: "空间",
		Name: "Space",
		Result: "",
		Type: 66
	}, {
		Label: "颜色",
		Name: "Colour",
		Result: "",
		Type: 66
	}, {
		Label: "形状",
		Name: "Form",
		Result: "",
		Type: 66
	}, {
		Label: "长度",
		Name: "Longness",
		Result: "",
		Type: 66
	}, {
		Label: "本体感觉",
		Name: "Proprioception",
		Result: "",
		Type: 66
	}],

	courseFrom: {
		Run: '',
		Jump: '',
		Walk: '',
		Bore: '',
		Creep: '',
		Roll: '',
		StrideAcross: '',
		Glissade: '',
		Climb: '',
		Throw: '',
		BounceBall: '',
		TransmissionConnection: '',
		Impact: '',
		Kick: '',
		Prehension: '',
		Winding: '',
		Turn: '',
		Spread: '',
		Endlong: '',
		Balance: '',
		Coordinate: '',
		Sensitive: '',
		Flexible: '',
		UpperLimbStrength: '',
		LowerLimbStrength: '',
		Association: '',
		RuleConsciousness: '',
		Teamwork: '',
		Competitive: '',
		ExerciseHabit: ''
	}
});

/***/ })

},[165]);


// WEBPACK FOOTER //
// static/js/app.87f1b0eefd2c11a38b8a.js